

import React from "react";
import {Box} from "@mui/material";
import Leadership from "./Leadership"
import AboutSection from "./AboutSection";









export default function About() {
  return (
  
     
      <>
        <AboutSection />
        <Box sx={{ mt: 10 }}>
          
            <Leadership />
         

        </Box>
         
    </>


  );
}
